// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme AG Grid through its own CSS variables (works in both light and dark). */
.ag-theme-alpine,
.ag-theme-alpine-dark {
  --ag-background-color: var(--card);
  --ag-foreground-color: var(--foreground);
  --ag-secondary-foreground-color: var(--muted-foreground);
  --ag-header-background-color: var(--muted);
  --ag-header-foreground-color: var(--muted-foreground);
  --ag-border-color: var(--border);
  --ag-row-border-color: var(--border);
  --ag-row-hover-color: var(--card-hover);
  --ag-odd-row-background-color: transparent;
  --ag-selected-row-background-color: var(--primary-soft);
  --ag-range-selection-border-color: var(--primary);
  --ag-input-focus-border-color: var(--primary);
  --ag-checkbox-checked-color: var(--primary);
  --ag-control-panel-background-color: var(--card);
  --ag-tooltip-background-color: var(--popover);
  --ag-font-family: var(--font-sans);
}

.ag-theme-alpine .ag-root-wrapper,
.ag-theme-alpine-dark .ag-root-wrapper {
  border-radius: var(--radius-lg);
}

.ag-header-cell:last-child .ag-header-cell-resize {
    display: none;
}

.page-body{
  height: calc(100% - 72px)!important;
  padding: 16px;
}

.grid-container {
  flex: 1 1; /* Fill remaining height */
}
`, "",{"version":3,"sources":["webpack://./src/components/Datatable/agGrid.css"],"names":[],"mappings":"AAAA,gFAAgF;AAChF;;EAEE,kCAAkC;EAClC,wCAAwC;EACxC,wDAAwD;EACxD,0CAA0C;EAC1C,qDAAqD;EACrD,gCAAgC;EAChC,oCAAoC;EACpC,uCAAuC;EACvC,0CAA0C;EAC1C,uDAAuD;EACvD,iDAAiD;EACjD,6CAA6C;EAC7C,2CAA2C;EAC3C,gDAAgD;EAChD,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;EACE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,SAAO,EAAE,0BAA0B;AACrC","sourcesContent":["/* Theme AG Grid through its own CSS variables (works in both light and dark). */\n.ag-theme-alpine,\n.ag-theme-alpine-dark {\n  --ag-background-color: var(--card);\n  --ag-foreground-color: var(--foreground);\n  --ag-secondary-foreground-color: var(--muted-foreground);\n  --ag-header-background-color: var(--muted);\n  --ag-header-foreground-color: var(--muted-foreground);\n  --ag-border-color: var(--border);\n  --ag-row-border-color: var(--border);\n  --ag-row-hover-color: var(--card-hover);\n  --ag-odd-row-background-color: transparent;\n  --ag-selected-row-background-color: var(--primary-soft);\n  --ag-range-selection-border-color: var(--primary);\n  --ag-input-focus-border-color: var(--primary);\n  --ag-checkbox-checked-color: var(--primary);\n  --ag-control-panel-background-color: var(--card);\n  --ag-tooltip-background-color: var(--popover);\n  --ag-font-family: var(--font-sans);\n}\n\n.ag-theme-alpine .ag-root-wrapper,\n.ag-theme-alpine-dark .ag-root-wrapper {\n  border-radius: var(--radius-lg);\n}\n\n.ag-header-cell:last-child .ag-header-cell-resize {\n    display: none;\n}\n\n.page-body{\n  height: calc(100% - 72px)!important;\n  padding: 16px;\n}\n\n.grid-container {\n  flex: 1; /* Fill remaining height */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
